import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, CheckCircle2Icon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 relative overflow-hidden" data-id="element-153">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/20 rounded-full blur-[150px] pointer-events-none" data-id="element-154" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-155">
        <FadeIn className="text-center mb-16" data-id="element-156">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-157">
            Tu Inversión Profesional
          </h2>
          <p className="text-xl text-gray-400" data-id="element-158">
            Acceso inmediato y de por vida a todo el material.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-159">
          <div id="pricing-card" className="bg-gradient-to-b from-card to-background border-2 border-primary/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)] relative overflow-hidden" data-id="element-160">
            {/* Decorative ribbon */}
            <div className="absolute top-6 -right-12 bg-red-600 text-white font-bold text-sm py-1 px-12 rotate-45 shadow-lg uppercase tracking-wider" data-id="element-161">
              Oferta Limitada
            </div>

            <div className="text-center mb-10" data-id="element-162">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-163">
                Pack Completo Bases del Entrenamiento de Fuerza
              </h3>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-164">
                <span className="text-gray-400 line-through text-xl" data-id="element-165">
                  $45.000 ARS
                </span>
                <span className="bg-green-500/20 text-green-500 px-3 py-1 rounded-full text-sm font-bold" data-id="element-166">
                  Ahorrás 55%
                </span>
              </div>
              <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary mb-4" data-id="element-167">
                $19.990{' '}
                <span className="text-2xl text-gray-400 font-medium" data-id="element-168">ARS</span>
              </div>
              <p className="text-primary font-semibold flex items-center justify-center gap-2" data-id="element-169">
                <ZapIcon className="w-5 h-5" data-id="element-170" />
                Un solo pago. Acceso de por vida.
              </p>
            </div>

            <div className="bg-background/50 border border-card-border rounded-2xl p-6 mb-10" data-id="element-171">
              <h4 className="font-bold text-white mb-4" data-id="element-172">Incluye:</h4>
              <ul className="space-y-3" data-id="element-173">
                {['Base Técnica de 140 Ejercicios Analizados', 'Checklists rápidas de ejecución', 'Bono 1: Bases Nutricionales del Desarrollo Muscular', 'Bono 2: La Práctica Profesional del Entrenador Personal'].map((item, index) => <li key={index} className="flex items-center gap-3 text-gray-300" data-id="element-174">
                    <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-175" />
                    <span data-id="element-176">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div id="pricing-cta" className="flex flex-col items-center gap-6" data-id="element-177">
              <Button fullWidth href="https://checkout.nuvoraplus.online/cart/53229091651952:1" className="md:py-6 md:text-2xl max-w-md mx-auto" data-id="element-178">
                Quiero mi pack ahora
              </Button>
              <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-179">
                <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-180" />
                <span data-id="element-181">Compra 100% segura, acceso inmediato.</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}